import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { FAMILY_HEADER, familyHeaderFor } from '../utils/familyScope';

const httpLink = createHttpLink({
  // Same origin as the page (https), forwarded to the backend by src/setupProxy.js, so it
  // works via localhost or any LAN address without editing .env.
  uri: process.env.REACT_APP_GRAPHQL_URL || `${window.location.origin}/graphql`,
});

const authLink = setContext(({ operationName }, { headers }) => {
  const token = localStorage.getItem('token');
  const familyId = familyHeaderFor(operationName, window.location.pathname);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      ...(familyId && { [FAMILY_HEADER]: familyId }),
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;
